'use client';

import Image, { type ImageLoader, type ImageLoaderProps, type ImageProps } from 'next/image';

import { useContextData } from '@common/useContextData';

// FIXME: Dirty fix to make it work in storybook
declare global {
    interface Window {
        __STORYBOOK_PREVIEW__: unknown;
    }
}
const isStoryBook = typeof window === 'object' && window?.__STORYBOOK_PREVIEW__;
const storybookImageLoader = ({ src }: ImageLoaderProps) => src;

//** imageLoader is used to make sure the host is replaced by NEXT_PUBLIC_ASSET_PREFIX properly */
const getImageLoader =
    (publicAssetPrefix: string | undefined): ImageLoader =>
    (props: ImageLoaderProps) =>
        `${publicAssetPrefix ?? ''}/_next/image?url=${encodeURIComponent(props.src)}&w=${props.width}&q=${
            props.quality || 75
        }`;

//** StaticImage should be used to serve images within the /public/images folder  */
export const StaticImage = (props: ImageProps) => {
    const { env } = useContextData();
    const defaultLoader = isStoryBook ? storybookImageLoader : getImageLoader(env.NEXT_PUBLIC_ASSET_PREFIX);

    return <Image {...props} loader={props.loader || defaultLoader} alt={props.alt || ''} />;
};
